// tslint:disable:no-any (autogenerated)
import stylesActions from '../../services/customization/customization-actions';
import bootstrapLog from './bootstrap-log';

export async function getStyles(): Promise<any> {
    bootstrapLog('Styles loaded in', 'Loading styles...');
    return stylesActions.getStylesIfNotLoaded().then(() => {
        bootstrapLog('Styles loaded in', 'Styles loaded.');
    });
}
